import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Language} from "../../../models/language";
import {Location} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../../../service/user.service";
import {UserRole} from "../../../enums/UserRole";
import {UserResponse} from "../../../interface/userResponse";
import {SnackBarUtil} from "../../../qr-copy-message/snack-bar-util.service";
import {MockupDataModel} from "../../../qr-copy-message/mockup-data.model";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {UserEditProfileComponent} from "../../../user-edit-profile/user-edit-profile.component";
import {LanguageService} from "../../../service/language.service";
import {LANG} from "../../../constants/local-storage.contant";
import {ShoppingCartService} from "../../../service/shoppingCart.service";
import {SharedService} from "../../../service/shered.service";
import {CookieUtils} from "../../../utils/cookie.utils";

@Component({
  selector: 'app-homepage-header',
  templateUrl: './homepage-header.component.html',
  styleUrls: ['./homepage-header.component.scss', './homepage-header-media.component.scss', '../../../header/user-info-menu.scss'],
})
export class HomepageHeaderComponent implements OnInit {

  @Input() isHomepageHeader: boolean = false;
  @Input() pageName: string = '';

  isMenuOpened: boolean = false;
  currentRoute: string;

  profileImage: any;
  profileImageUrl?: string | null = null;
  isAdmin: boolean = false;
  currentUser?: UserResponse;
  showRightButtons: boolean = false;
  total: number = 0

  protected readonly menuItems = [
    {title: 'home-page-content.all_products', routerLink: '/products'},
    {title: 'home-page-content.prices', routerLink: '/prices'},
    {title: 'home-page-content.about_us', routerLink: '/about-us'},
    {title: 'home-page-content.contact', routerLink: '/contact-us'},
  ]

  lang = '';

  constructor(
    private router: Router,
    private location: Location,
    private translateService: TranslateService,
    private userService: UserService,
    private snackBarUtil: SnackBarUtil,
    private dialog: MatDialog,
    private languageService : LanguageService,
    private shoppingCartService: ShoppingCartService,
    private sharedService: SharedService
  ) {
    this.currentRoute = this.router.url;
  }

  ngOnInit(): void {
    this.userService.clearAdminRole();
    this.lang = CookieUtils.getCookie(LANG) || Language.HY;
    this.translateService.use(this.lang);
    this.loadCartTotal()
    this.initCurrentUserInUserService();
    this.sharedService.updatedBadgeTotal.subscribe(_=>{
      this.loadCartTotal()
    })
  }

  loadCartTotal(): void {
    this.shoppingCartService.getBucketItemsTotalForCurrentUser().subscribe(total => {
      this.total = total;
    });
  }

  get hasCurrentUser() {
    return !!(this.currentUser);
  }

  goBack(): void {
    const currentUrl = this.router.url;
    if (currentUrl === '/shipping-method' || currentUrl.startsWith('/shipping-method')) {
      this.router.navigate(['/cart']);
    } else {
      this.location.back();
    }
  }

  toggleMenu() {
    this.isMenuOpened = !this.isMenuOpened;
  }

  menuClosed() {
    this.isMenuOpened = false;
  }

  changeLang(lang: string) {
    this.languageService.setLanguage(lang);
    this.lang = lang;
  }

  logout(): void {
    this.userService.logoutAndNavigateToLogin();
  }

  logoutAdmin(): void {
    this.userService.logoutAdmin();
  }

  showProfileEdit(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      user: this.currentUser,
      profileImageUrl: this.profileImageUrl
    };

    dialogConfig.panelClass = 'edit-container';

    this.dialog.open(UserEditProfileComponent, dialogConfig).afterClosed().subscribe({
      next: (data: any) => {
        if (data?.user) {
          this.currentUser = data.user;
        }
        if(data?.isPictureChanged) {
          this.initializeCurrentUserDetails();
        }
        if(data?.isCurrentProfilePictureDeleted) {
          this.profileImageUrl = null;
          this.profileImage = null;
        }
      }
    });
  }

  redirectToCards() {
    this.router.navigate(["/cards"]).then();
  }

  private initCurrentUserInUserService() {
    const email = this.userService.email;
    if(email.length === 0) {
      this.showRightButtons = true;
      return
    }
    this.userService.findByEmail(email).subscribe({
      next: response => {
        this.currentUser = response;
        this.isAdmin = this.userService.role == UserRole.ADMIN;
        this.initializeCurrentUserDetails();
      },
      error: () => {
        this.showRightButtons = true;
      }
    })
  }

  private initializeCurrentUserDetails() {
    if(!this.currentUser) {
      this.showRightButtons = true;
      return
    }
    this.userService.getProfileImage(BigInt(this.currentUser?.id)).subscribe({
      next: (imageData) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          this.profileImage = e.target?.result as string;
          this.profileImageUrl = this.profileImage;
        };
        fileReader.readAsDataURL(imageData);
      },
    })
  }

  private showSnackBar(data: MockupDataModel, panelClass: string) {
    this.snackBarUtil.openSnackBar({
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass],
      data: data
    });
  }

  protected readonly Language = Language;
}
